import { render, staticRenderFns } from "./BrandMediaLogo.vue?vue&type=template&id=a7236900&scoped=true&"
import script from "./BrandMediaLogo.vue?vue&type=script&lang=ts&"
export * from "./BrandMediaLogo.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMediaLogo.vue?vue&type=style&index=0&id=a7236900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7236900",
  null
  
)

export default component.exports